import { useCallback, useState } from 'react'

import Axios from '../networking/intraceptor'
import { pharmacy_user_supernova_access } from '../networking/urlEndPoints'
import { authToken } from '../storage/authToken'
import { useAdminStealthHidden } from './useAdminStealth'

const isEnabled = (value) => value === true || value === 1 || value === '1' || value === 'true'

// Reads only Super Nova's two feature conditions. If an older backend cannot
// serve the endpoint, callers keep the existing login-based behaviour.
const useSuperNovaAccess = ({ adminModule, oatSheetEnabled }) => {
    const [access, setAccess] = useState(null)
    const token = authToken()
    // This hook re-reads admin_module from its own endpoint, so the
    // effective value computed in allSelectors would be overwritten here.
    // Apply admin screen privacy (F9 x5) to the resolved value as well, so
    // the Super Nova entry hides with the rest of the admin navigation.
    const adminStealthHidden = useAdminStealthHidden()

    const refresh = useCallback(() => {
        const fallback = {
            adminModule: Number(adminModule),
            oatSheetEnabled: isEnabled(oatSheetEnabled),
        }

        if (!token) {
            setAccess(null)
            return Promise.resolve(fallback)
        }

        return Axios.get(pharmacy_user_supernova_access)
            .then((response) => {
                const body = response?.data
                const data = body?.data || body
                if (!data || typeof data.admin_module === 'undefined' || typeof data.oat_sheet_enable === 'undefined') {
                    return fallback
                }

                const nextAccess = {
                    adminModule: Number(data.admin_module),
                    oatSheetEnabled: isEnabled(data.oat_sheet_enable),
                }
                setAccess(nextAccess)
                return nextAccess
            })
            .catch(() => fallback)
    }, [adminModule, oatSheetEnabled, token])

    return {
        adminModule: adminStealthHidden ? 0 : (access?.adminModule ?? Number(adminModule)),
        oatSheetEnabled: access?.oatSheetEnabled ?? isEnabled(oatSheetEnabled),
        refresh,
    }
}

export default useSuperNovaAccess
